import dayjs from "dayjs";

export const getYearFromSearchParams = (
  searchParams: URLSearchParams,
): number => {
  const yearParam = searchParams.get("year");

  if (yearParam) {
    const parsed = parseInt(yearParam, 10);

    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }

return dayjs().year();
};

